import "../sparkle_namespace.js";

window.Sparkle ??= {};
window.Sparkle.Utilities ??= {};

window.Sparkle.Utilities.getUrlParam = function (param) {
  var url = new URL(window.location.href);
  return url.searchParams.get(param);
};
